export default "__VITE_ASSET__CTTU9Gus__"